import { styled } from "styled-components";

const CircledNumberContainer = styled.div`
  width: ${({ theme }) => theme.FONT.SIZE.EXTRA_LARGE};
  height: ${({ theme }) => theme.FONT.SIZE.EXTRA_LARGE}; // rem becauz im boss
  border-radius: 100%;
  background-color: ${({ theme }) => theme.COLORS.SECONDARY};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-family: ${({ theme }) => theme.FONT.FAMILY.BODY};
  font-size: ${({ theme }) => theme.FONT.SIZE.SMALL};
  font-weight: ${({ theme }) => theme.FONT.WEIGHT.SEMIBOLD};
`;

const CircledNumberContainerZero = styled(CircledNumberContainer)`
  color: ${({ theme }) => theme.COLORS.GRAY_BLACK};
  background-color: ${({ theme }) => theme.COLORS.GRAY_MEDIUM};
`;

export const CircledNumber = ({ number }: { number: number }) => {
  const renderedNumber = number > 99 ? "∞" : number;
  if (number === 0) {
    return <CircledNumberContainerZero>0</CircledNumberContainerZero>;
  }
  return <CircledNumberContainer>{renderedNumber}</CircledNumberContainer>;
};
